import {
	getStoreDashboardDetailApi,
	getStoreDashboardBannerApi,
	addStoreDashboardBannerApi,
} from '../../services/bToC/storeDashboard';
import { getErrorObject } from '../../utilities/utils';
import { IStoreDashboardBannerModel } from '../../models/storeDashboard';

export const types = {
	// Dashboard Data
	STORE_DASHBOARD_DETAIL_REQUEST: 'storeDashboard/STORE_DASHBOARD_DETAIL_REQUEST',
	STORE_DASHBOARD_DETAIL_SUCCESS: 'storeDashboard/STORE_DASHBOARD_DETAIL_SUCCESS',
	STORE_DASHBOARD_DETAIL_FAILURE: 'storeDashboard/STORE_DASHBOARD_DETAIL_FAILURE',
	// Banner Data
	STORE_DASHBOARD_BANNER_REQUEST: 'storeDashboard/STORE_DASHBOARD_BANNER_REQUEST',
	STORE_DASHBOARD_BANNER_SUCCESS: 'storeDashboard/STORE_DASHBOARD_BANNER_SUCCESS',
	STORE_DASHBOARD_BANNER_FAILURE: 'storeDashboard/STORE_DASHBOARD_BANNER_FAILURE',
	// Add Banner Data
	STORE_DASHBOARD_ADD_BANNER_REQUEST: 'storeDashboard/STORE_DASHBOARD_ADD_BANNER_REQUEST',
	STORE_DASHBOARD_ADD_BANNER_SUCCESS: 'storeDashboard/STORE_DASHBOARD_ADD_BANNER_SUCCESS',
	STORE_DASHBOARD_ADD_BANNER_FAILURE: 'storeDashboard/STORE_DASHBOARD_ADD_BANNER_FAILURE',
};

const initialState = {
	count: 0,
	isLoading: false,
	isBannerLoading: false,
	error: null,
	data: [],
	banners: [],
};

export const storeDashboard = (state = initialState, action) => {
	switch (action.type) {
		case types.STORE_DASHBOARD_DETAIL_REQUEST:
		case types.STORE_DASHBOARD_DETAIL_SUCCESS:
		case types.STORE_DASHBOARD_DETAIL_FAILURE:
			return storeDashboardDetailReducer(state, action);
		case types.STORE_DASHBOARD_BANNER_REQUEST:
		case types.STORE_DASHBOARD_BANNER_SUCCESS:
		case types.STORE_DASHBOARD_BANNER_FAILURE:
			return storeDashboardBannerReducer(state, action);
		case types.STORE_DASHBOARD_ADD_BANNER_REQUEST:
		case types.STORE_DASHBOARD_ADD_BANNER_SUCCESS:
		case types.STORE_DASHBOARD_ADD_BANNER_FAILURE:
			return storeDashboardBannerReducer(state, action);
		default:
			return state;
	}
};

const storeDashboardDetailReducer = (state, action) => {
	switch (action.type) {
		case types.STORE_DASHBOARD_DETAIL_REQUEST:
			return { ...state, isLoading: true };
		case types.STORE_DASHBOARD_DETAIL_SUCCESS:
			return { ...state, isLoading: false, error: null, data: action.payload };
		case types.STORE_DASHBOARD_DETAIL_FAILURE:
			return { ...state, isLoading: false };
		default:
			return state;
	}
};

const storeDashboardBannerReducer = (state, action) => {
	switch (action.type) {
		case types.STORE_DASHBOARD_BANNER_REQUEST:
			return { ...state, isBannerLoading: true };
		case types.STORE_DASHBOARD_BANNER_SUCCESS:
			return { ...state, isBannerLoading: false, error: null, banners: action.payload };
		case types.STORE_DASHBOARD_BANNER_FAILURE:
			return { ...state, isBannerLoading: false, error: action.payload.error };
		default:
			return state;
	}
};

export const getStoreDashboardDetail = () => {
	return async (dispatch) => {
		dispatch({ type: types.STORE_DASHBOARD_DETAIL_REQUEST });
		try {
			const response = await getStoreDashboardDetailApi();
			const payload = response.data.Data;

			dispatch({
				type: types.STORE_DASHBOARD_DETAIL_SUCCESS,
				payload,
			});
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.STORE_DASHBOARD_DETAIL_FAILURE));
		}
	};
};

export const getStoreDashboardBanner = () => {
	return async (dispatch) => {
		dispatch({ type: types.STORE_DASHBOARD_BANNER_REQUEST });
		try {
			const response = await getStoreDashboardBannerApi();
			const payload = response.data.Data;

			dispatch({
				type: types.STORE_DASHBOARD_BANNER_SUCCESS,
				payload,
			});
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.STORE_DASHBOARD_BANNER_FAILURE));
		}
	};
};

export const addStoreDashboardBanner = (data: IStoreDashboardBannerModel) => {
	return async (dispatch) => {
		dispatch({ type: types.STORE_DASHBOARD_BANNER_REQUEST });
		try {
			await addStoreDashboardBannerApi(data);

			dispatch({
				type: types.STORE_DASHBOARD_BANNER_SUCCESS,
			});
		} catch (error) {
			dispatch(promiseCatchBlock(error, types.STORE_DASHBOARD_BANNER_FAILURE));
		}
	};
};

const promiseCatchBlock = (error: any, type: string) => {
	return (dispatch) => {
		const { message } = getErrorObject(error);
		dispatch({
			type: type,
			payload: { error: message },
		});
	};
};
